import i18n from "@tecma/i18n";
import { DateTime } from "luxon";
import { getCorrectDatesForConstraints } from "@tecma/date-picker-utils";

import { RentConstraints } from "../types/dates";

const getDateFromIso = (date: string) => DateTime.fromISO(date).toISODate();
const getDateFromSeconds = (date: string) =>
  DateTime.fromMillis(Number(date)).toISODate();

export const getDatesFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const startDateParam: string | null = urlParams.get("start")
    ? urlParams.get("start")
    : null;
  const endDateParam: string | null = urlParams.get("start")
    ? urlParams.get("end")
    : null;

  const startDate = startDateParam
    ? getDateFromIso(startDateParam) ||
      getDateFromSeconds(startDateParam) ||
      "1970-01-01"
    : null;
  const endDate = endDateParam
    ? getDateFromIso(endDateParam) ||
      getDateFromSeconds(endDateParam) ||
      "1970-01-01"
    : null;

  return {
    startDate,
    endDate,
  };
};

export const getInitialDates = (rentConstraints: RentConstraints) => {
  const { startDate, endDate } = getDatesFromUrl();
  const initialStartDate =
    DateTime.fromISO(rentConstraints.firstRentableDate ?? "").toISODate() ??
    DateTime.now().toISODate();
  const currentDate =
    DateTime.fromISO(rentConstraints.firstRentableDate ?? "")
      .diffNow()
      .valueOf() < 0
      ? DateTime.now().toISODate()
      : initialStartDate;

  const [validStartDate, validEndDate] = getCorrectDatesForConstraints(
    [startDate ?? currentDate, endDate ?? currentDate],
    rentConstraints,
    currentDate,
  );
  return {
    startDate: validStartDate,
    endDate: validEndDate,
  };
};

export const DatesFormatter = (
  date?: string | Date | null,
  options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "short",
  },
) => {
  if (date) {
    if (typeof date === "string") {
      const dateFormatted = DateTime.fromISO(date).toJSDate();
      return new Intl.DateTimeFormat(i18n.language, options).format(
        dateFormatted,
      );
    }
    return new Intl.DateTimeFormat(i18n.language, options).format(date);
  }
  return "";
};

export const getLocalizedDates = (date: string) =>
  DateTime.fromFormat(date, "yyyy-MM-dd")
    .setLocale(i18n.language)
    .toLocaleString(DateTime.DATE_MED);
